import { useState, useMemo } from "react";
import { PRODUCTS, TIER_GROUPS } from "@/data/products";
import { ProductCard } from "@/components/ProductCard";
import { ProductDialog } from "@/components/ProductDialog";
import { FILTER } from "@/constants/testIds";

export const ProductGrid = () => {
  const [filter, setFilter] = useState("all");
  const [selected, setSelected] = useState(null);

  const products = useMemo(() => {
    if (filter === "all") return PRODUCTS;
    return PRODUCTS.filter((p) => p.tier === filter);
  }, [filter]);

  return (
    <section id="catalogo" className="py-20 md:py-28 bg-[#F4F2EC]">
      <div className="container-wide">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="overline">Catálogo</span>
            <h2 className="font-serif text-4xl md:text-5xl text-[#2D4A3E] leading-tight mt-3">
              Coroas para cada homenagem
            </h2>
            <p className="mt-4 text-[#5C5C5C] leading-relaxed">
              Toque em um modelo para escolher quantidade, personalizar a faixa de homenagem
              e enviar o pedido diretamente pelo WhatsApp.
            </p>
          </div>

          <div className="flex flex-wrap gap-2">
            {TIER_GROUPS.map((g) => (
              <button
                key={g.id}
                data-testid={FILTER[g.id] || `filter-${g.id}`}
                onClick={() => setFilter(g.id)}
                className={`px-4 py-2 rounded-full border text-sm transition-all duration-300 ${
                  filter === g.id
                    ? "bg-[#2D4A3E] text-white border-[#2D4A3E]"
                    : "bg-white text-[#1C1C1C] border-[#E5E3DB] hover:border-[#2D4A3E]"
                }`}
              >
                {g.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
          {products.map((p) => (
            <ProductCard key={p.ref} product={p} onClick={() => setSelected(p)} />
          ))}
        </div>
      </div>

      <ProductDialog product={selected} onClose={() => setSelected(null)} />
    </section>
  );
};
